import { useMutation } from "@tanstack/react-query"
import { Loader } from "lucide-react"
import { toast } from "sonner"

import { Button } from "@/components/ui/button"

import { refreshCache } from "../api/refreshCache"

export default function CacheRefresh() {
  const mutation = useMutation({
    mutationFn: refreshCache,
    onSuccess: () => toast("Cache Refresh Successful"),
    onError: () => toast("Cache Refresh Error"),
  })

  return (
    <Button onClick={() => mutation.mutate()} disabled={mutation.isPending} className="w-[175px]">
      {mutation.isPending ? <Loader className="animate-spin" /> : "Refresh KPI Cache"}
    </Button>
  )
}
